"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindFunctions = bindFunctions;
exports.canUseDom = void 0;
exports.deepMerge = deepMerge;

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

//import deepMerge from 'merge-deep';
function deepMerge() {
  var sourceA = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var sourceB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var extended = _extends({}, sourceA);

  Object.keys(sourceB).forEach(function (key) {
    //console.log("SOURCEA= "+ JSON.stringify(sourceA) + " SOURCEB= "+JSON.stringify(sourceB));
    //console.log("sourceB key is " +JSON.stringify(key)+ '; sourceB[key] = ' + JSON.stringify(sourceB[key]));
    if (Array.isArray(sourceB[key])) {
      if (typeof sourceA[key] === 'undefined') extended[key] = _toConsumableArray(sourceB[key]);else extended[key] = _objectSpread({}, sourceB[key]);
    } else if (_typeof(sourceB[key]) !== "object" || !sourceB[key]) {
      extended[key] = sourceB[key];
    } else {
      if (!sourceB[key]) {
        extended[key] = sourceB[key];
      } else {
        extended[key] = deepMerge(sourceA[key], sourceB[key]);
      }
    }
  }); //console.log("RESULT="+JSON.stringify(extended));

  return extended;
} // export function deepMerge(source, target = {}) {
//   // initialize with source styles
//   const styles = { ...source }
//   // massage in target styles
//   Object.keys(target).forEach(key => {
//     if (source[key]) {
//       styles[key] = (rsCss, props) => {
//         return target[key](source[key](rsCss, props), props)
//       }
//     } else {
//       styles[key] = target[key]
//     }
//   })
//   return styles
// }


var canUseDom = !!(typeof window !== "undefined" && window.document && window.document.createElement);
/**
 * Bind multiple conponent methods:
 * @param {this} context
 * @param {Array} functions
 *
 * constructor() {
 *   ...
 *   bindFunctions.call(this, ['handleClick', 'handleOther'])
 * }
 */

exports.canUseDom = canUseDom;

function bindFunctions(functions) {
  var _this = this;

  functions.forEach(function (f) {
    return _this[f] = _this[f].bind(_this);
  });
}